module.exports = __webpack_public_path__ + "img/arrow_left_2.9ddc5d9a.svg";